<template>
    <div class="banner-app">
        <div class="banner-app-icon">
            <img
                src="/uploads/images/icons/consent-app.png"
                alt="Apple Store"
            >
        </div>
        <div class="banner-app-text">
            <Typo :html="text" />
        </div>
        <div class="banner-app-items">
            <a
                href="https://play.google.com/store/apps/details?id=pl.itcraft.makroapp"
                target="_blank"
                rel="noreferrer"
                title="Pobierz aplikację MAKRO w Google Play"
            >
                <img
                    src="/uploads/images/app/google.png"
                    alt="Google Play"
                >
            </a>
            <a
                href="https://itunes.apple.com/us/app/makro/id1146761397?ls=1&mt=8"
                target="_blank"
                rel="noreferrer"
                title="Pobierz aplikację MAKRO w App Store"
            >
                <img
                    src="/uploads/images/app/apple-store.png"
                    alt="Apple Store"
                >
            </a>
            <a
                href="https://appgallery.huawei.com/#/Featured"
                target="_blank"
                rel="noreferrer"
                title="Pobierz aplikację MAKRO w App Gallery"
            >
                <img
                    src="/uploads/images/app/app-gallery.png"
                    alt="App Gallery"
                >
            </a>
        </div>
    </div>
</template>

<script>
import Typo from '@/components/typo/Typo'
export default {
    components: { Typo },
    props: {
        text: {
            type: String,
            required: true,
        }
    }
}
</script>

<style lang="scss">
.banner-app {
    position: relative;
    display: flex;
    align-items: center;
    background: $color-default-contrast;
    padding: 25px 25px 25px 55px;
    margin-top: 20px;

    &-icon {
        margin-right: 55px;
    }

    &-text {
        width: calc(100% - 524px);
        padding-right: 20px;
    }

    &-items {
        display: flex;

        a {
            margin-left: 10px;
        }
    }

    @media (max-width: $screen-laptop) {
        flex-wrap: wrap;

        &-icon {
            margin-right: 25px;
        }

        &-text {
            width: calc(100% - 100px);
            padding-right: 0;
        }

        &-items {
            width: 100%;
            margin-top: 40px;
        }
    }

    @media (max-width: $screen-mobile-extra-large) {
        padding: 20px;

        &-text {
            &-text {
                width: calc(100% - 68px);
            }
        }

        &-items {
            flex-direction: column;
            align-items: center;

            a {
                margin: 0 0 20px;
            }
        }
    }
}
</style>
